// The epilogue's field (docs/182 EP1): the opening fight's own look — the board's ground kit, hour,
// weather and season, as `encounter_stage` stamped them — for the backdrop and the line under the title.
import { SKY_WORDS, hourWords } from '../../../core/story/calendar';
import { storyDate, type Genesis, type StorySeason, type StoryWeather } from '../../../core/story/genesis';
import { parseWeather } from '../../../game/weather/weather';
import type { BackdropStage } from './Scene';

/** The fight's look: the board's kit, hour, weather and season (docs/23). */
export interface EpilogueField { stage: BackdropStage; season?: StorySeason }

const SEASONS: readonly StorySeason[] = ['Spring', 'Summer', 'Autumn', 'Winter'];
const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/** The fight's stage row read as the backdrop wants it; `undefined` when there is none (a World from before it). */
export function fieldOf(row: { kit: string; hour: number; weather: string; season: number; country?: string } | undefined): EpilogueField | undefined {
  if (!row) return undefined;
  const w = parseWeather(row.weather);
  const weather = (w ? cap(w.kind) : 'Clear') as StoryWeather;
  // season 255: the World had no clock yet
  return { stage: { hour: row.hour, weather, kit: row.kit || undefined, ...(row.country ? { country: row.country } : {}) }, season: SEASONS[row.season] };
}

/** "Dusk · rain · 3rd week of Leaffall, 412 AR" for the fight's field, as the board had it. */
export function fieldLine(g: Pick<Genesis, 'calendar'>, field: EpilogueField): string {
  const when = cap(hourWords(field.stage.hour));
  const sky = SKY_WORDS[field.stage.weather.toLowerCase()] ?? field.stage.weather.toLowerCase();
  const date = field.season && g.calendar?.season === field.season ? storyDate(g.calendar) : field.season ?? '';
  return [when, sky, date].filter(Boolean).join(' · ');
}
